import { CPDPoints } from "components/CPDPoints";
import renderExperts from "components/Dashboard/renderExperts";
import renderPartners from "components/Dashboard/renderPartners";
import renderSponsors from "components/Dashboard/renderSponsors";
import moment from "moment";
import React, { PropTypes } from "react";
import WebinarSponsorsRepresentative from "../../../WebinarSponsorsRepresentative";
import { connect } from "react-redux";
import { noImagePlaceholder } from "../../../../constants/baseConst";

const CurrentWebinarItem = ({
  webinar: {
    webinar_title,
    start_date,
    end_date,
    sponsor,
    sponsors,
    partnerships,
    joined,
    users_join_url,
    experts,
  },
  currentGroup: { logo_url, title },
  userRole,
  user,
  subscriptionAction,
  webinar,
}) => {
  const canRegister =
    userRole !== "sponsor" || user.sponsor_type === "pharmaceutical";
  return (
    <div className="section_previous">
      <p className="section_topic">{webinar_title}</p>
      <div className="section_info row">
        <div className="col l3 webinar_title">
          <p className="section_previous_theme"></p>
          {partnerships && partnerships.length && partnerships.length > 0 ? (
            <div>
              <p>In partnership with:</p>
              {renderPartners(partnerships)}
            </div>
          ) : null}
        </div>
        {webinar && webinar.document_url ? (
          <div className="col l1">
            <div className="current_points">
              Agenda:
              <a
                className="download_attachment"
                target="_blank"
                href={webinar.document_url}
              >
                Download
              </a>
            </div>
          </div>
        ) : null}
        {/* {Boolean(webinar.sponsor_representative.length) && (
          <div className="col l2">
            <WebinarSponsorsRepresentative
              sponsors={webinar.sponsor_representative}
            />
          </div>
        )} */}
        <div className="col l2 section_topic">
          {webinar.vimeo_url && webinar.duration ? (
            <div>
              <p className="current_card_date">Duration</p>
              <p className="current_card_time">{webinar.duration}</p>
            </div>
          ) : (
            <div>
              <p className="current_card_date">
                <span>
                  {moment(start_date).format("MMM DD").toUpperCase()}{" "}
                </span>
                {moment(start_date).format("YYYY")}
              </p>
              <p className="current_card_time">
                {moment(start_date).format("h:mm a").toUpperCase()}
                {" - "}
                {moment(end_date).format("h:mm a").toUpperCase()}
              </p>
            </div>
          )}
        </div>
        <div className="col l2">
          <img
            className="group-card-image"
            src={logo_url || noImagePlaceholder}
          />
          <h6 style={{ textAlign: "center" }}>{title}</h6>
        </div>
        <div className="col l1">
          <div className="current_points">
            <CPDPoints webinar={webinar} />
          </div>
        </div>
        <div className="col l2">
          <div>
            <div className="current_join">
              {canRegister && (
                <button href="javascript:void(0)" onClick={subscriptionAction}>
                  {joined || users_join_url ? "OPEN WEBINAR" : "JOIN WEBINAR"}
                </button>
              )}
            </div>
            {/* {webinar.ext_cpd_points === 0 && webinar.int_cpd_points === 0 ? null :
              <div className="current_points">
                <CPDPoints webinar={webinar} />
              </div>
            } */}
          </div>
          <div className="click_register"></div>
        </div>
      </div>
      {renderExperts(experts)}
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentGroup: state.studygroups.studygroup,
  user: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({});

CurrentWebinarItem.propTypes = {
  webinar: PropTypes.obj,
  joinToWebinar: PropTypes.func,
  userRole: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentWebinarItem);



// WEBPACK FOOTER //
// ./src/components/StudyGroupsUser/StudyGroupUserWebinars/Current/CurrentWebinarItem.js